import React, { useState, useEffect } from 'react'
import ResultBall from './ResultBall'

const GameHistory = ({ results })=>(
    <table className='w-full'>
    <thead className='w-full flex p-2 px-6 justify-between bg-orange-500'>
        <th><p className='w-[75px] text-center font-semibold text-white'>Period</p></th>
        <th><p className=' text-center font-semibold text-white'>Number</p></th>
        <th><p className='w-[35px] text-center font-semibold text-white'>B/s</p></th>
        <th><p className=' text-center font-semibold text-white'>Color</p></th>
    </thead>
    <tbody>
    {results && results.map((result, index)=>(
    <tr key={result.period} className='odd:bg-gray-100 even:bg-orange-100 flex py-2 px-6 justify-between items-center'>
        <td>
        <p className='text-start text-sm'>{result.period}</p>
        </td>
        <td>
        <p className={`  text-center text-${result.number >= 5 ? 'green' : 'orange'}-600 font-semibold`}>{result.number}</p>
        </td>
        <td>
        <p className='w-[35px] text-center text-sm'>{result.number > 5 ? 'Big' : 'Small'}</p>
        </td>
        <td>
        <div className=' w-[25px] flex justify-center items-center space-x-2'>
            {
                result.number >= 5 && <div className={`w-[10px] h-[10px] rounded-full bg-${result.number >= 5 ? 'green' : 'orange'}-600`}/>
            }
            {
                result.number <= 4 && <div className={`w-[10px] h-[10px] rounded-full bg-${result.number >= 5 ? 'green' : 'orange'}-600`}/>
            }
        </div>
        </td>
    </tr>
    ))}
    </tbody>
</table>
    )


    const Chart = ({ results })=>(
        <table className='w-full'>
    <thead className='w-full flex p-2 px-6 justify-between bg-orange-500'>
        <th><p className='w-[75px] text-center font-semibold text-white'>Period</p></th>
        <th><p className=' text-center font-semibold text-white'>Number</p></th>
    </thead>
    <tbody>
    {results && results.map((result, index)=>(
    <tr key={result.period} className='odd:bg-gray-100 even:bg-orange-100 flex py-2 px-2 justify-between items-center'>
        <td>
        <p className='text-start text-sm'>{result.period}</p>
        </td>
        <td className='flex justify-center items-center space-x-1'>
        {Array.from({ length: 10 }, (_, i) => (
        i === result.number ? <ResultBall i={i} />
        :
        <p className={`w-[18px] h-[18px] flex justify-center items-center rounded-full text-[0.875rem] text-center text-gray-400 border border-gray-400 font-semibold`}>{i}</p>
        ))}
        <p className={`text-sm w-[18px] h-[18px] flex justify-center items-center text-white  ${result.number >=5 ? 'bg-yellow-500' : 'bg-blue-500'} rounded-full text-center text-sm`}>{result.number > 5 ? 'B' : 'S'}</p>
        </td>
        <td>
        
        </td>
    </tr>
    ))}
    </tbody>
</table>
    )

    const MyHistory = ({ results })=>(
        <div>
            <p>My History</p>
        </div>
    )
    
const ResultBoard = () => {
const [ results, setResults ] = useState([])



    
    const [ currentSection, setCurrentSection ] = useState('')
    const fetchedResults = [
        {
            period:'2503090285',
            number:7,
        },{
            period:'2503090285',
            number:5,
        },{
            period:'2503090285',
            number:4,
        },{
            period:'2503090285',
            number:6,
        },{
            period:'2503090285',
            number:2,
        },{
            period:'2503090285',
            number:1,
        },{
            period:'2503090285',
            number:0,
        },{
            period:'2503090285',
            number:8,
        },{
            period:'2503090285',
            number:9,
        },{
            period:'2503090285',
            number:3,
        },
    ]

    const sections = [
        {
            name: 'Game history',
            component:<GameHistory results={fetchedResults}/>
        },
        {
            name: 'Chart',
            component:<Chart results={fetchedResults}/>
        },
        {
            name: 'My history',
            component:<MyHistory results={fetchedResults}/>
        },
    ]  

    useEffect(()=>{
       setCurrentSection(sections[0]) 
       setResults(fetchedResults)     
    }, [])

    return (
    <div>
        <div className='flex space-x-2 mt-4 items-center'>
            {sections.map((section, index) =>(
                <p key={index} onClick={() => setCurrentSection(section)} className={` ${section.name === currentSection.name ? 'bg-orange-600 text-white' : 'bg-gray-300 text-gray-500'} p-2 rounded-t-lg text-center min-w-[108px] h-[34px] cursor-pointer`}>{section.name}</p>
            ))}
        </div>
        {currentSection.component}    
        <div className='flex justify-center items-center space-x-6 p-4'>
            <p className='font-semibold text-white p-2 px-4 rounded-[5px] cursor-pointer bg-gray-400'>L</p>
            <p className='text-gray-800 text-sm'>1/3200</p>
            <p className='font-semibold text-white p-2 px-4 rounded-[5px] cursor-pointer btn-bg'>R</p>
        </div>
    </div>
  )
}

export default ResultBoard